import React, { useState, useEffect } from "react";
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid'
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import TextField from '@material-ui/core/TextField';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Menu from '../../../Components/LockerMenu'
import Footer from '../../../Components/Footer'
import Loaders from '../../../Components/Loader'
// import Tokens from './tabs/tokens'
// import Pairs from './tabs/pairs'

import '../browser.css'
import './lpLock.css'
import Lock from '../../../images/lockicon.png'
import BUST from '../../../images/fantomicon.png'
import PCSW from '../../../images/SpookySwap.png'
  



/* ***********************
**   Import Web3
*********************** */
import Web3 from "web3";

var web3;
var abc = '0'; 
let contract;
let finalAccount;
let accounts
let mainAdd;
let mainABI;
let mainContract;
const today = new Date();

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));


const LPLock = () => {
  let url_string = window.location.href;
  let url = new URL(url_string);
  let pramValue = url.searchParams.get("pair");

  const [value, setValue] = React.useState(0);
  const classes = useStyles();
  const [tabVal, settabVal] = useState(0)
  const [useABI, setABI] = useState()
  const [useSearchCoinAdd, setSearchCoinAdd] = useState()
  const [useSearchCoinBal, setSearchCoinBal] = useState('0')
  const [useSearchCoinBalSS, setSearchCoinBalSS] = useState('0')
  const [useSearchCoinBalSetinput, setSearchCoinBalSetinput] = useState('0')
  const [useSearchCoinName, setSearchCoinName] = useState()
  const [useSearchCoinSymbol, setSearchCoinSymbol] = useState()
  const [useSearchCoinNamePOne, setSearchCoinNamePOne] = useState()
  const [useSearchCoinSymbolPOne, setSearchCoinSymbolPOne] = useState()
  const [useSearchCoinSymbolPOneIcon, setSearchCoinSymbolPOneIcon] = useState()
  const [useSearchCoinNamePTwo, setSearchCoinNamePTwo] = useState()
  const [useSearchCoinSymbolPTwo, setSearchCoinSymbolPTwo] = useState()
  const [useSearchCoinADDPOne, setSearchCoinADDPOne] = useState()
  const [useSearchCoinADDPTwo, setSearchCoinADDPTwo] = useState()
  const [useSearchBNBBal, setSearchBNBBal] = useState('0')
  const [useSearchCoinDec, setSearchCoinDec] = useState()
  const [useUnlockDate, setUnlockDate] = useState()
  const [useAmount, setAmount] = useState()
  const [useError, setError] = useState('d-none')
  const [usePercentBTN1, setPercentBTN1] = useState('')
  const [usePercentBTN2, setPercentBTN2] = useState('')
  const [usePercentBTN3, setPercentBTN3] = useState('')
  const [usePercentBTN4, setPercentBTN4] = useState('')
  const [useApproveBTN, setApproveBTN] = useState('')
  const [useLockBTN, setLockBTN] = useState('d-none')
  const [useLoader, setLoader] = useState('none')
  

  // Visibility States 
  const [usewalletBtn, setwalletBtn] = useState(true)
  const [useWalletNT, setWalletNT] = useState(false)
  const [useForms, setForms] = useState(false)
  const [useSearchAddressError, setSearchAddressError] = useState(false)
  const [usedateError, setdateError] = useState(false)
  const [useAmountError, setAmountError] = useState(false)
  const [useBNBError, setBNBError] = useState(false)
  // const [useLockHidderBtn, setLockHidderBtn] = useState(true)


  
  useEffect(()=> {
    connectWallet();
    handleSearch();
  },[useSearchCoinSymbolPOneIcon]);
  const connectWallet = () => {
    if(window.web3 !== undefined){
      //connect to web3
      web3 = new Web3(window.ethereum);
     
      // our ABI 
      mainAdd = '0x8D217DfC9FA1F7ab52fBAEfa9f09fb28Df6f664C';
      mainABI = [{"inputs":[{"internalType":"contract IUniFactory","name":"_uniswapFactory","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"lpToken","type":"address"},{"indexed":false,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"lockDate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"unlockDate","type":"uint256"}],"name":"onDeposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"lpToken","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"onWithdraw","type":"event"},{"inputs":[],"name":"gFees","outputs":[{"internalType":"uint256","name":"ethFee","type":"uint256"},{"internalType":"contract IERCBurn","name":"secondaryFeeToken","type":"address"},{"internalType":"uint256","name":"secondaryTokenFee","type":"uint256"},{"internalType":"uint256","name":"secondaryTokenDiscount","type":"uint256"},{"internalType":"uint256","name":"liquidityFee","type":"uint256"},{"internalType":"uint256","name":"referralPercent","type":"uint256"},{"internalType":"contract IERCBurn","name":"referralToken","type":"address"},{"internalType":"uint256","name":"referralHold","type":"uint256"},{"internalType":"uint256","name":"referralDiscount","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_index","type":"uint256"}],"name":"getLockedTokenAtIndex","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getNumLockedTokens","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"}],"name":"getNumLocksForToken","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"}],"name":"getUserLockForTokenAtIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"}],"name":"getUserLockedTokenAtIndex","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"}],"name":"getUserNumLockedTokens","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"address","name":"_lpToken","type":"address"}],"name":"getUserNumLocksForToken","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"}],"name":"getUserWhitelistStatus","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_index","type":"uint256"}],"name":"getWhitelistedUserAtIndex","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getWhitelistedUsersLength","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"incrementLock","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_amount","type":"uint256"},{"internalType":"uint256","name":"_unlock_date","type":"uint256"},{"internalType":"address payable","name":"_referral","type":"address"},{"internalType":"bool","name":"_fee_in_eth","type":"bool"},{"internalType":"address payable","name":"_withdrawer","type":"address"}],"name":"lockLPToken","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"migrate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"uint256","name":"_unlock_date","type":"uint256"}],"name":"relock","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address payable","name":"_devaddr","type":"address"}],"name":"setDev","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_referralPercent","type":"uint256"},{"internalType":"uint256","name":"_referralDiscount","type":"uint256"},{"internalType":"uint256","name":"_ethFee","type":"uint256"},{"internalType":"uint256","name":"_secondaryTokenFee","type":"uint256"},{"internalType":"uint256","name":"_secondaryTokenDiscount","type":"uint256"},{"internalType":"uint256","name":"_liquidityFee","type":"uint256"}],"name":"setFees","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"contract IMigrator","name":"_migrator","type":"address"}],"name":"setMigrator","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"contract IERCBurn","name":"_referralToken","type":"address"},{"internalType":"uint256","name":"_hold","type":"uint256"}],"name":"setReferralTokenAndHold","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_secondaryFeeToken","type":"address"}],"name":"setSecondaryFeeToken","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"splitLock","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"tokenLocks","outputs":[{"internalType":"uint256","name":"lockDate","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"initialAmount","type":"uint256"},{"internalType":"uint256","name":"unlockDate","type":"uint256"},{"internalType":"uint256","name":"lockID","type":"uint256"},{"internalType":"address","name":"owner","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"address payable","name":"_newOwner","type":"address"}],"name":"transferLockOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"uniswapFactory","outputs":[{"internalType":"contract IUniFactory","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"bool","name":"_add","type":"bool"}],"name":"whitelistFeeAccount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"}];

      mainContract = new web3.eth.Contract(mainABI, mainAdd);
      window.ethereum.request({ method: 'eth_requestAccounts' }).then(_accounts => {
          accounts = _accounts;
          finalAccount = accounts[0];
          setwalletBtn(false) 
      });  
    }
    else{
        //if Metamask is not installed
    }
  }
  const handleDated = (val,type) => {
    setdateError(false)
    let value = val.target.value.toLowerCase();
    const result =new Date(value).getTime()
    const todayDate =new Date(today).getTime()
    if(todayDate > result){
      console.log('Wrong Time Selecteed')
      setdateError(true)
    }else{
      setdateError(false)
    }
    setUnlockDate((result/1000))
  }
  const handleSearch = (event) => {

    if(window.web3 !== undefined){
      setSearchCoinAdd(pramValue);
      const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
      };
        setABI('123456')
        //connect to web3
        web3 = new Web3(window.ethereum);
        console.log('fectumTest3: ', useABI)
        let str = pramValue;
        let res = str.substring(0, 2);
        if( res == '0x' ){
          try {
            let addreabiss =  [{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount0Out","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1Out","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Swap","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint112","name":"reserve0","type":"uint112"},{"indexed":false,"internalType":"uint112","name":"reserve1","type":"uint112"}],"name":"Sync","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"DOMAIN_SEPARATOR","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MINIMUM_LIQUIDITY","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"PERMIT_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"burn","outputs":[{"internalType":"uint256","name":"amount0","type":"uint256"},{"internalType":"uint256","name":"amount1","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"getReserves","outputs":[{"internalType":"uint112","name":"_reserve0","type":"uint112"},{"internalType":"uint112","name":"_reserve1","type":"uint112"},{"internalType":"uint32","name":"_blockTimestampLast","type":"uint32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_token0","type":"address"},{"internalType":"address","name":"_token1","type":"address"}],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"kLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"mint","outputs":[{"internalType":"uint256","name":"liquidity","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"permit","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"price0CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"price1CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"skim","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount0Out","type":"uint256"},{"internalType":"uint256","name":"amount1Out","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"swap","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"sync","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"token0","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"token1","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"}];

            contract = new web3.eth.Contract(addreabiss, pramValue)
            
            contract.methods.symbol().call().then( result => {
              setForms(true)
              setSearchAddressError(false)
              setError('d-none')
              setSearchCoinSymbol(result)
            })
            contract.methods.name().call().then( result => {
              setSearchCoinName(result)
            })
            contract.methods.decimals().call().then( result => {
              setSearchCoinDec(result)
            })
            contract.methods.token0().call().then( result => {
              setSearchCoinADDPOne(result)
              findPair(result,'one')
            })
            contract.methods.token1().call().then( result => {
              setSearchCoinADDPTwo(result)
              findPair(result,'two')
            })
            contract.methods.balanceOf(finalAccount).call().then( result => {
              setSearchCoinBal((result))
              setSearchCoinBalSS(financial(result,5,'yes'))
              setSearchCoinBalSetinput((result/1e18))
            })
            contract.methods.allowance(finalAccount,mainAdd).call().then( result => {
              console.log('Allownance Check: ', result)
              if( result > 1 ){
                setApproveBTN('d-none')
                setLockBTN('d-block')
              }else{
                setApproveBTN('d-block')
                setLockBTN('d-none')
              }
            })
            web3.eth.getBalance(finalAccount).then( result => {
              setSearchBNBBal((result/1e18))
            })
          } catch(error) {
            setForms(false)
            web3.eth.getChainId().then( _chainId => {
              if( _chainId != 250){
                setForms(false)
                setSearchAddressError(false)
                setWalletNT(true)
              }else{
                setForms(false) 
                setSearchAddressError(true)
                setWalletNT(false)
              }
            });
            console.log('Error getting fake datasdfsdfs: ' + error);
          }
        }else{
          setForms(false)
          setSearchAddressError(true)
          setError('d-block')
        }
      
      // })
      // .catch(error => {
      //   setForms(false)
      //   setSearchAddressError(true)
      // console.log('Error getting fake data: ' + error);
      // })
    }else{
      alert('Connect your wallet first..!')
    }

  }
  const findPair = (val,pairno) => {
    // const requestOptions = {
    //   method: 'GET',
    //   headers: {
    //       'Content-Type': 'application/json',
    //   },
    // };
    // fetch('https://api.bscscan.com/api?module=contract&action=getabi&address=' + val + '&apikey=MQYTQ9M7Y68II3IW1BDMU7Z3CR42KIKHDZ',requestOptions)
    // .then(response => response.json())
    // .then(response => {
        try{
          setABI('123456')
          // let Pairabc = response.result;
          //connect to web3
          web3 = new Web3(window.ethereum);
          setError('d-none')
          let addreabissPair =  [{"inputs":[{"internalType":"string","name":"name","type":"string"},{"internalType":"string","name":"symbol","type":"string"},{"internalType":"uint256","name":"cap","type":"uint256"},{"internalType":"uint256","name":"totalSupply","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"cap","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}];

          let contractPair = new web3.eth.Contract(addreabissPair, val);
          contractPair.methods.symbol().call().then( result => {
            if( pairno == 'one' ){
              setSearchCoinSymbolPOne(result)
              let str = result;
              let res = str.substring(0, 1);
              setSearchCoinSymbolPOneIcon(res)
            }else if ( pairno == 'two' ){
              setSearchCoinSymbolPTwo(result)
            }
          });
        } catch(error) {
          console.log('Error getting pair data: ' + error);
        }
      // })
      // .catch(error => {
      // console.log('Error getting pair data: ' + error);
      // })
  }
  const handleAmount = (val,type) => {
    // if( val > 0.01 ){
    //   setAmountError(false)
    // }
    if( type == 'srch'){
      let valuea = val.target.value.toLowerCase();
      setPercentBTN1('')
      setPercentBTN2('')
      setPercentBTN3('')
      setPercentBTN4('')
      setAmount(valuea)
      if(valuea > useSearchCoinBalSetinput){
        setAmountError(true)
      }else if(valuea <= 0){
        setAmountError(true)
      }else{
        setAmountError(false)
      }
    }else if( type == '25'){
      let valueb = (type/100)*val;
      setPercentBTN1('percentBTNhover')
      setPercentBTN2('')
      setPercentBTN3('')
      setPercentBTN4('')
      setAmount(valueb)
      if(valueb > useSearchCoinBalSetinput){
        setAmountError(true)
      }else if(valueb <= 0){
        setAmountError(true)
      }else{
        setAmountError(false)
      }
    // financial(useAmount, 8, 'yes' )
    }else if( type == '50'){
      let valuec = (type/100)*val;
      setAmount(valuec)
      setPercentBTN1('percentBTNhover')
      setPercentBTN2('percentBTNhover')
      setPercentBTN3('')
      setPercentBTN4('')
      if(valuec > useSearchCoinBalSetinput){
        setAmountError(true)
      }else if(valuec <= 0){
        setAmountError(true)
      }else{
        setAmountError(false)
      }
    }else if( type == '75'){
      let valued = (type/100)*val;
      setAmount(valued)
      setPercentBTN1('percentBTNhover')
      setPercentBTN2('percentBTNhover')
      setPercentBTN3('percentBTNhover')
      setPercentBTN4('')
      if(valued > useSearchCoinBalSetinput){
        setAmountError(true)
      }else if(valued <= 0){
        setAmountError(true)
      }else{
        setAmountError(false)
      }
    }else{
      setAmount(val)
      setPercentBTN1('percentBTNhover')
      setPercentBTN2('percentBTNhover')
      setPercentBTN3('percentBTNhover')
      setPercentBTN4('percentBTNhover')
      if(val > useSearchCoinBalSetinput){
        setAmountError(true)
      }else if(val <= 0){
        setAmountError(true)
      }else{
        setAmountError(false)
      }
    }
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleLock = () => {
    // lp ADD
    if (useSearchCoinAdd == "" ){
      alert('0')
      return;
    }
    if (useAmount == "" || useAmount <= 0.01 || isNaN(useAmount)){
      setAmountError(true)
      return;
    }
    if (useUnlockDate == "" || useUnlockDate == 0 || isNaN(useUnlockDate)){
      setdateError(true)
      return;
    }
    if (useSearchBNBBal == "" || useSearchBNBBal < 0.01 || isNaN(useSearchBNBBal)){
      setBNBError('yes')
      return;
    }
    let convertedamounttostr1 = useAmount.toString()
    let convertedamounttostr = web3.utils.toWei(convertedamounttostr1, 'ether')
    console.log('amount', convertedamounttostr)
    setdateError(false)
    setAmountError(false)
    setLoader('block');
    try {
      mainContract.methods.lockLPToken(
        useSearchCoinAdd, 
        convertedamounttostr,
        useUnlockDate,
        "0x0000000000000000000000000000000000000000",
        true,
        finalAccount)
        .send({ 
          from: accounts[0], 
          value: web3.utils.toWei('1', 'ether')
        }).then( result => {
          setLoader('none');
          window.location.reload();
      })
      .catch(error => {
        setLoader('none')
        console.log('Error getting fake data 1234: ' , error);
      });
    } catch (error) {
      setLoader('none')
        console.log('Error getting fake data 1234: ' , error);
    }
    
          // gasPrice:10000e9,
          // gasLimit: 300000
    // , value: 10 * 1e18
  }
  const handleApprove = () => {
    setLoader('block');
    contract.methods.approve(mainAdd, '115792089237316195423570985008687907853269984665640564039457584007913129639935')
    .send({from: finalAccount}).then( test => {
      contract.methods.allowance(finalAccount,mainAdd).call().then( result => {
        setLoader('none');
        if( result > 1 ){
          setApproveBTN('d-none')
          setLockBTN('d-block')
        }else{
          setApproveBTN('d-block')
          setLockBTN('d-none')
        }        
      })
    })
    .catch(error => {
      setLoader('none')
      console.log('Error getting fake data 1234: ' , error);
    });

  }
  const financial = (num,digit,sint) => {
    if (sint == 'yes') {
      let val = num/1e18;
      return Number.parseFloat(val).toFixed(digit);
    }else{
      return Number.parseFloat(num).toFixed(digit);
    }
  }
  const tabsChange = (event, newValue) => {
    settabVal(newValue);
  };


  return (
    <div className="pcc---slider">
      <Loaders
        loaderDisplay = {useLoader}
      />
      <Menu />
        <Container maxWidth="lg">
            <Grid
              container
              justify="flex-start"
              alignItems="flex-start"
            >
              <Grid 
                  xs={12}
                  className="text-left pb-4"
              >
                <Grid
                    container
                    justify="center"
                    alignItems="center"
                    className="px-0"
                >
                  <Grid 
                      container 
                      justify="center" 
                      direction="column"
                      md={8}
                      xs={12}
                      className="pt-5 my-5 Token--locker px-sm-5 "
                  >
                    
                    <Grid 
                        justify="center" 
                        direction="column"
                        xs={12}
                        md={12}
                        className="Your--balance"
                    > 
        
                    { usewalletBtn ? 
                    <Grid 
                        justify="center" 
                        direction="column"
                        xs={12}
                        className="mt-5 mb-5 pb-5 text-center"
                    >

                        <img className="mx-auto" src={Lock} alt="Lock Logo" />

                        <h2 className="text-center text-light py-4 "><strong>Liquidity Locker</strong></h2>
                        <button className="collect--wallet py-4" onClick={connectWallet}>
                        <AccountBalanceWalletIcon style={{width: '35px',marginTop: '-11px'}} /><span className="h3"><strong>Connect Wallet</strong></span>
                        </button>
                    </Grid>
                    :
                    <p className="m-0" />
                    }
                    {useWalletNT ? 
                      <Grid 
                        container 
                        justify="center" 
                        direction="column"
                        xs={12}
                        className="mx-auto mt-5"
                      >
                        <p className="mb-2 text-danger"><b>Error: </b>Please set Fantom as your active network</p>
                      </Grid>
                      :
                      <p className="m-0" />
                    }
                    { useSearchAddressError ?
                      <div className="text-danger d-flex mt-4 mb-0 px-2 mx-auto w-100" role="alert">
                        <ErrorOutlineIcon className="mr-2" style={{color:'red',fontSize:18,marginTop: 2}}/>
                        <span className="d-inline-block">Invalid LP Token.</span>
                      </div>
                    :
                      <p className="m-0" />
                    }
                    {useForms ?
                        <Grid 
                            container 
                            justify="center" 
                            direction="column"
                            xs={12}
                            className="mx-auto mb-5"
                        >
                            <div className="px-sm-4 text-center mb-4">
                                <img className="mx-auto" src={Lock} alt="Lock Logo" />
                                {/* <h6 className="m-0 mt-3" style={{color: '#fbc41a'}}>Pair</h6> */}
                                
                                <h4 className="mt-3 text-light d-flex mb-0 text-center text-light" style={{alignSelf:'center',justifyContent: 'center'}}>
                                  { useSearchCoinSymbolPOne != 'WFTM' ?  
                                    <span className='QMF---locker-sybmol'>{useSearchCoinSymbolPOneIcon}</span> 
                                    :
                                    <img src={BUST} style={{height:"100%",width:'auto',maxHeight:28,marginRight: 5}}/>
                                  }
                                  <strong>{useSearchCoinSymbolPOne}</strong>
                                  <strong className="mx-2 d-inline-block">/</strong>
                                  { useSearchCoinSymbolPTwo != 'WFTM' ?  
                                    <span className='QMF---locker-sybmol'>{useSearchCoinSymbolPOneIcon}</span> 
                                    :
                                    <img src={BUST} style={{height:"100%",width:'auto',maxHeight:28,marginRight: 5}}/>
                                  }
                                  <strong>{useSearchCoinSymbolPTwo}</strong>
                                </h4>
                                <h6 className="m-0 mt-3 mb-2" style={{color: '#fbc41a'}}>Exchange</h6>
                                <h4 className="text-light ">
                                    <strong>
                                        <img src={PCSW} alt="Lock Logo" className="mr-2" />
                                        
                                        SpookySwap
                                    </strong>
                                </h4>
                            </div>

                            <div className="view--Locks--section2 py-4 px-md-5">
                            <h3 className="mb-4 text-center" style={{color: '#fbc41a'}}>Lock Liquidity</h3>
                            <div className="lock--token-1section py-4 px-4">
                                <p className="mb-3 text-light"><strong>Lock how many tokens?</strong></p> 
                                <div className="lock--token pcc--lock--token py-4 px-4" >
                                    <p className="word text-right text-light">Balance: {useSearchCoinBalSS}</p>
                                    <h4 style={{float:'left'}}> 
                                    <input 
                                        className="input"
                                        onChange={(event,type) =>handleAmount(event,'srch')}
                                        value={useAmount}
                                        type="number"
                                        placeholder="0.0"
                                    />
                                    </h4>
                                    <h4 className="text-right decimal pcc--decimal">
                                    {useSearchCoinSymbol} 
                                    <button className="lcock--button ml-2" onClick={(bal,type) =>handleAmount(useSearchCoinBalSetinput,'btn')}>Max</button></h4>
                                </div>
                                <div className="px-3 pb-3" style={{backgroundColor: '#0d1124'}} >
                                <Grid 
                                    container 
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    xs={12}
                                    >
                                    <Grid 
                                        xs={3}
                                        sm={3}
                                        className="px-0"
                                        style={{width: '25%'}}
                                    >
                                        <button className={usePercentBTN1 + " buttonper percentBTN pt-2"} onClick={(bal,type) =>handleAmount(useSearchCoinBalSetinput,'25')}>25%</button>
                                    </Grid>
                                    <Grid 
                                        xs={3}
                                        sm={3}
                                        className="px-0"
                                        style={{width: '25%'}}
                                    >
                                        <button className={usePercentBTN2 + " buttonper percentBTN pt-2"} onClick={(bal,type) =>handleAmount(useSearchCoinBalSetinput,'50')}>50%</button>
                                    </Grid>
                                    <Grid 
                                        xs={3}
                                        sm={3}
                                        className="px-0"
                                        style={{width: '25%'}}
                                    >
                                        <button className={usePercentBTN3 + " buttonper percentBTN pt-2"} onClick={(bal,type) =>handleAmount(useSearchCoinBalSetinput,'75')}>75%</button>
                                    </Grid>
                                    <Grid 
                                        xs={3}
                                        sm={3}
                                        className="px-0"
                                        style={{width: '25%'}}
                                    >
                                        <button className={usePercentBTN4 + " buttonper percentBTN pt-2"} onClick={(bal,type) =>handleAmount(useSearchCoinBalSetinput,'btn')}>100%</button>
                                    </Grid>
                                    <Grid 
                                        xs={12}
                                        className="px-0"
                                    >
                                        {/* <i className="mb-0 d-block w-100 text-left" style={{fontSize: '10px'}}>NOTE: Minimum LP amount is 0.01</i><br /> */}
                                        { useAmountError ? 
                                        <div className="text-danger d-flex mt-1 mb-0 px-2 mx-auto w-100 text-left" role="alert">
                                            <ErrorOutlineIcon className="mr-2" style={{color:'red',fontSize:18,marginTop: 2}}/>
                                            <span className="d-inline-block">Select a valid LP Token amount.</span>
                                        </div>
                                        :
                                        <p className="m-0" />
                                        }
                                    </Grid>
                                    {/* <div className=" row text-center pt-3 pb-3 px-2" >
                                    
                                    
                                    </div> */}
                                
                                </Grid>
                                </div>
                                <div>
                                <p className="mt-3 text-light"><strong >Unlock on date</strong></p>
                                <div className="lock--token py-4 px-4">
                                    <div  noValidate className="w-100">
                                    <TextField className="clander--timer"
                                        id="datetime-local"
                                        label=""
                                        type="datetime-local"
                                        // defaultValue="2017-05-24T10:30"
                                        className={classes.textField + ' w-100 QMF---inputLock'}
                                        InputLabelProps={{
                                        shrink: true,
                                        }}
                                        onChange={(event) =>handleDated(event)}
                                    />
                                    {usedateError ?
                                        <div className="text-danger d-flex mt-1 mb-0 px-2 mx-auto w-100 text-left" role="alert">
                                        <ErrorOutlineIcon className="mr-2" style={{color:'red',fontSize:18,marginTop: 2}}/>
                                        <span className="d-inline-block">Select a valid date and time for unlocking the LP Token.</span>
                                        </div>
                                    :
                                        <p className="m-0" />
                                    }
                                    </div>
                                </div>
                                </div>

                            </div>
                            </div>
                            <div className="mt-5">
                            <div className="py-4 bnb--box mx-auto">
                                <h3 className=" px-4 text-center">10 FTM</h3>
                                {/* <p className="text-center">(+1% KTR)</p> */}
                            </div>
                            <p className="py-2 text-center" style={{color: '#828282'}}>Your balance: {financial(useSearchBNBBal, 2, 'no')} FTM</p>
                            {useSearchBNBBal < 10 || useBNBError ?
                                <div className="text-danger d-flex mt-1 mb-0 px-2 mx-auto w-100 text-left" role="alert">
                                <ErrorOutlineIcon className="mr-2" style={{color:'red',fontSize:18,marginTop: 2}}/>
                                <span className="d-inline-block">You do not have enough FTM in your wallet to perform this transaction. 10 FTM are required.</span>
                                </div>
                            :
                                <p className="m-0"></p>
                            }
                            <p className="text-center text-light">Once tokens are locked they cannot be withdrawn under any circumstances
                                until the timer has expired. Please ensure the parameters are correct, as they
                                are final.
                            </p>
                            </div>
                            <Grid 
                            container
                            justify="center" 
                            direction="row"
                            xs={12}
                            md={12}
                            className="mt-4"
                            > 
                            <Grid 
                                justify="center" 
                                direction="column"
                                xs={12}
                                className="position-relative"
                            > 
                                <button 
                                className={useApproveBTN + " Approve--button py-3 w-100"}
                                onClick={handleApprove}
                                >
                                Approve
                                </button>

                                {/* { useLockHidderBtn ? 
                                <div className="pcc---Locker_hiddenButton"></div>
                                :
                                <p className="m-0" />
                                } */}
                                <button 
                                className={useLockBTN + " Approve--button py-3 w-100"}
                                onClick={handleLock}
                                >
                                Lock
                                </button>
                            </Grid>
                            <div className="mx-auto">
                            {/* <button className=" Approve--button py-3" style={{backgroundColor: '#efefef',border: '1px solid #efefef',color:'#707070'}}>Approve</button>
                            <button className="Lock--button py-3" style={{color:'#707070'}}>Lock</button> */}
                            
                            
                            </div>
                            </Grid>
                        </Grid>
                    :
                    <p className="m-0" />
                    }
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
        </Container>
      <Footer />
    </div> 
  );
}

export default LPLock;
